import { render, staticRenderFns } from "./BaseLoader.vue?vue&type=template&id=377b08ce&scoped=true"
import script from "./BaseLoader.vue?vue&type=script&lang=js"
export * from "./BaseLoader.vue?vue&type=script&lang=js"
import style0 from "./BaseLoader.vue?vue&type=style&index=0&id=377b08ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377b08ce",
  null
  
)

export default component.exports